import type { Permission } from '@arquivo-morto/contracts';
import { Button } from '@fluentui/react-components';
import { Navigate, Outlet, useNavigate } from 'react-router';
import { type ModuleDef, pagePath } from '#src/app/navigation/module';
import { useAccess } from '#src/auth/session';
import { StatusScreen } from '#src/shared/StatusScreen';

function GoHome() {
  const navigate = useNavigate();
  return (
    <Button appearance="primary" onClick={() => navigate('/')}>
      Ir para o início
    </Button>
  );
}

export function AccessDenied() {
  return (
    <StatusScreen
      tone="denied"
      title="Sem acesso a esta página"
      description="O seu perfil não inclui esta funcionalidade. Se precisar dela, peça acesso a um administrador."
      action={<GoHome />}
    />
  );
}

export function NotFound() {
  return (
    <StatusScreen
      title="Página não encontrada"
      description="O endereço não existe ou mudou."
      action={<GoHome />}
    />
  );
}

/** Renderiza as rotas filhas só para quem tem a permissão. */
export function RequirePermission({
  permission,
}: {
  permission: Permission | undefined;
}) {
  const can = useAccess();
  return can(permission) ? <Outlet /> : <AccessDenied />;
}

/** Entrada do módulo (`/admin`): leva à primeira página que a pessoa pode abrir. */
export function ModuleIndex({ module }: { module: ModuleDef }) {
  const can = useAccess();
  const first = module.pages.find((page) => can(page.permission));
  if (first === undefined) {
    return <AccessDenied />;
  }
  return <Navigate to={pagePath(module, first)} replace />;
}
